import { useMediaQuery } from '@mui/material';
import { GridColumn as Column } from '@progress/kendo-react-grid';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { breakpoints } from 'src/assets/_responsive-mixin';
import { BooleanCell } from 'src/components/shared/DataGrid/BooleanCell';
import { DataGrid } from 'src/components/shared/DataGrid/DataGrid';
import { DateCell } from 'src/components/shared/DataGrid/DateCell';
import { GridCountCell } from 'src/components/shared/DataGrid/GridCountCell';
import { GradeDetailDto, GradeDto } from 'src/store/grades/grade';
import { CorrectionsListMobile } from './CorrectionsListMobile';

interface Props {
  grades: GradeDetailDto[];
  loading: boolean;
  onEdit: (grade: GradeDto) => void;
  onGradeClick: (grade: GradeDetailDto) => void;
}

export const CorrectionsList: React.FC<Props> = props => {
  const { grades, loading, onEdit, onGradeClick } = props;

  const { t } = useTranslation();
  const largeScreen = useMediaQuery(`(min-width: ${breakpoints.large})`);

  return largeScreen ? (
    <DataGrid
      items={grades}
      loading={loading}
      detail={props => (
        <DataGrid
          items={props.dataItem.gradeCorrections}
          style={{ marginTop: 20 }}
        >
          <Column field="parameter.name" title={t('parameter.singular')} />
          <Column field="instrument.name" title={t('instrument.singular')} />
          <Column field="correctionPart" title={t('grade.correctionPart')} />
          <Column field="user.initials" title={t('user.initials')} />
          <Column
            field="correctionDate"
            title={t('grade.correctionDate')}
            filterable={false}
            cell={props => <DateCell {...props} />}
          />
        </DataGrid>
      )}
      expandField="expanded"
      onRowClick={event => onEdit(event.dataItem)}
      onExpandChange={event => onGradeClick(event.dataItem)}
    >
      <Column
        field="no"
        width={200}
        title={t('grade.number')}
        footerCell={() => (
          <GridCountCell count={grades?.length} label={t('grade.plural')} />
        )}
      />
      <Column field="name" title={t('props.name')} />
      <Column field="description" title={t('props.description')} />
      <Column
        width="120px"
        field="active"
        filterable={false}
        title={t('props.active')}
        cell={props => <BooleanCell {...props} />}
      />
      <Column
        width="120px"
        field="internal"
        filterable={false}
        title={t('props.internal')}
        cell={props => <BooleanCell {...props} />}
      />
    </DataGrid>
  ) : (
    <CorrectionsListMobile {...props} />
  );
};
